import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      const storedUser = localStorage.getItem('user');
      
      if (token && storedUser) {
        try {
          const response = await authApi.getMe();
          setUser(response.data);
        } catch (error) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      }
      setLoading(false);
    };
    
    initAuth();
  }, []);

  const login = async (email, password) => {
    const response = await authApi.login({ email, password });
    const { token, user: userData } = response.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAdmin = () => user?.role === 'admin';
  const isFounder = () => user?.role === 'founder';
  const isSuperAdmin = () => user?.role === 'super_admin';
  const isAdminOrFounder = () => user?.role === 'admin' || user?.role === 'founder';
  const canDelete = () => user?.role === 'admin';  // Only admin can delete
  const canViewAll = () => user?.role === 'admin' || user?.role === 'founder';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isFounder, isSuperAdmin, isAdminOrFounder, canDelete, canViewAll }}>
      {children}
    </AuthContext.Provider>
  );
};
